import {makeStyles} from "@material-ui/core/styles";
import React, { useEffect, useRef, useState } from 'react';
import {Filter, ReferenceInput, useListContext, useTranslate, FunctionField} from 'react-admin';

import TextInputEx from "../../../components/_extensions/react-admin/input/TextInputEx";
import {ToggleDatesEnum, ToggleDatesFilter} from '../../../components/filters/ToggleDatesFilter';
import {ToggleInput, ToggleTitleInput} from '../../../components/filters/ToggleInputs';
import {ToggleStateFilter} from '../../../components/filters/ToggleStateFilter';
import {TERMINAL_ALL_VALUE, ToggleTerminalsFilter} from '../../../components/filters/ToggleTerminalsFilter';
import {CompanySelect, ExcludeCompanySelect} from '../../../components/inputs';
import {DateInput, TimeInput} from '../../../components/inputs/DateTimeInput';
import {SelectDisabledInput, SelectUppercaseInput} from '../../../components/inputs/SelectUppercaseInput';
import {OrderNormalStatuses, OrderStatus, OrderStatusActive} from '../../../entities/OrderStatus';
import { filterColors } from '../../../utils/constants';
import { CommodityInput } from '../forms/inputs/CommodityInput';
import {ServiceInputRaw} from '../forms/inputs/ServiceInput';
import {ToggleTypeFilter} from "./ToggleTypeFilter";

export const filterDefaultValues = {
	"eta_date|etd_date": [ToggleDatesEnum.TODAY],
	"terminal_id": [TERMINAL_ALL_VALUE],
};


const useStyles = makeStyles(t => ({	
	filterTerminal: {
		backgroundColor: filterColors.in_terminal
	},
	filterSearch: {
		backgroundColor: filterColors.search
	},
}));


export const OrdersFilter = ({hasCompanyFilter, hasOrderTypeFilter, isSearchInDocs, isOnlyDates, isDraft, ...props}) => {
	const translate = useTranslate();
	const classes = useStyles();

	return <Filter {...props}>
		{/* <TextInputEx label="Search" source="_query" alwaysOn /> */}
		{!isSearchInDocs && [
			<ToggleDatesFilter source="eta_date|etd_date" defaultValue={null} alwaysOn key={"eta_date|etd_date"}/>,
			!isOnlyDates && [
				<ToggleTerminalsFilter source="terminal_id" defaultValue={null} alwaysOn key={"terminal_id"}/>,
				!isDraft ? <ToggleInput source="in_terminal" value={true} alwaysOn key={"in_terminal"} label={translate("osfc.filters.toggles.in_terminal")} className={classes.filterTerminal} /> : null,
				!isDraft ? <ToggleStateFilter source="status_state" defaultValue={undefined} alwaysOn key={"status_state"}/> : null,
				hasOrderTypeFilter && <ToggleTypeFilter source="order_type" defaultValue={undefined} alwaysOn key={"order_type"}/>
			]
		]}

		{/* {!isOnlyDates && <ToggleInput source="is_search_in_docs" value={true} key={"is_search_in_docs"} label={translate("osfc.filters.toggles.search_in_docs")}  alwaysOn className={classes.filterSearch}/>} */}
		{!isSearchInDocs && isDraft && <ToggleInput source="is_external_draft" value={false} key="is_external_draft" alwaysOn label={translate("osfc.filters.toggles.external_draft_orders")} className={classes.filterTerminal} />}
		{!isSearchInDocs && isDraft && <ToggleInput source="is_unviewed_draft" value={false} key="is_unviewed_draft" alwaysOn label={translate("osfc.filters.toggles.unviewed_draft_orders")} className={classes.filterTerminal} />}
		{!isOnlyDates && <ToggleTitleInput source="is_search_in_docs" value={true} key={"is_search_in_docs"} label0={translate("osfc.filters.toggles.search_in_docs")} label1={translate("osfc.filters.toggles.back_to_orders")} alwaysOn className={classes.filterSearch}/>}
		
		{props.filterValues["eta_date"] && <DateInput source="eta_date" key={"eta_date"} disabled/>}
		{props.filterValues["eta_time"] && <TimeInput source="eta_time" key={"eta_time"} disabled/>}

		{props.filterValues["etd_date"] && <DateInput source="etd_date" key={"etd_date"} disabled/>}
		{props.filterValues["etd_time"] && <TimeInput source="etd_time" key={"etd_time"} disabled/>}

		{props.filterValues["etd_truck_id"] && <TextInputEx source="etd_truck_id" key={"etd_truck_id"} disabled/>}
		{props.filterValues["etd_truck"] && <TextInputEx source="etd_truck" key={"etd_truck"} disabled/>}

		{props.filterValues["eta_truck_id"] && <TextInputEx source="eta_truck_id" key={"eta_truck_id"} disabled/>}
		{props.filterValues["eta_truck"] && <TextInputEx source="eta_truck" key={"eta_truck"} disabled/>}

		{!isSearchInDocs && [
			<TextInputEx source="id" key={"id"} parse={elem => elem ? [elem] : []}/>,

			<TextInputEx label={"resources.orders.fields.reference"} source="reference|trip_number"
							 resettable key={"reference|trip_number"}/>,

			(hasCompanyFilter && [
				<ExcludeCompanySelect source="exclude_company_id" label="osfc.filters.exclude_company_id" 
									  allowEmpty={false} resettable key={"exclude_company_id"} />,
				<CompanySelect source="company_id" emptyValue={null} emptyText="All Companies" defaultValue={null} 
							   allowEmpty resettable key={"company_id"} />,
			]),

			!isDraft ? <ReferenceInput source="status" reference="order-statuses" resettable key={"status"} filter={{ id: OrderNormalStatuses }}>
				{isOnlyDates ? <SelectDisabledInput allowedIds={OrderStatusActive} optionText="name"/> : <SelectUppercaseInput optionText="name"/>}	
			</ReferenceInput> : null,

			!isDraft ? <ReferenceInput label="osfc.filters.si_status" source="si_status" reference="outgoing-doc-statuses" resettable key={"status"}>
				<SelectUppercaseInput optionText="name"/>
			</ReferenceInput> : null,

			<TextInputEx source="trip_number" resettable key={"trip_number"}/>,

			<ServiceInputRaw source="service" resettable key={"service"}/>,

			<TextInputEx label="Truck" source="eta_truck|eta_trailer|etd_truck|etd_trailer" resettable key={"Truck"}/>,

			<CompanySelect label="Transporter" source="eta_3rd_party|etd_3rd_party" emptyValue={null} refer="transporters" emptyText="All Companies" defaultValue={null} 
							allowEmpty resettable key={"3rd_party"} filter={{no_range: true}} />,

			<DateInput source="eta_etd_date" margin="dense" resettable key={"Date"} label="Date"/>,

			<TextInputEx label="Driver" source="eta_driver|etd_driver" resettable key={"driver"}/>,

			// <DateInput source="etd_date" margin="dense" resettable key={"etd_date"}/>,

			<CommodityInput source="commodity" resettable style={{minWidth:"140px"}}/>,

			<ReferenceInput source="cooler_type_id" reference="cooler-types" resettable key={"cooler_type_id"}>
				<SelectUppercaseInput optionText="name"/>
			</ReferenceInput>
		]}

		{isSearchInDocs && <TextInputEx label="Search in docs" source="doc_search_text" alwaysOn/>}
	</Filter>
};
